/**
 * אתחול עמוד חוות דעת — מיון לפי בחירת המשתמש.
 */
document.addEventListener("DOMContentLoaded", function () {
  var root = document.querySelector(".br-reviews");
  if (!root || !window.BusinessReviewsModule || typeof window.BusinessReviewsModule.sortItems !== "function") {
    return;
  }
  var select = root.querySelector(".br-reviews__sort");
  if (!select) {
    return;
  }
  function applySort() {
    window.BusinessReviewsModule.sortItems(root, select.value);
  }
  select.addEventListener("change", applySort);
});
